(function () {
    'use strict';

    angular.module('components.startup', [
        'ui.router',
        'components.api'
    ]);
})();